<script setup lang="ts">
    import { computed } from 'vue';
    import { getByPath, setByPath } from '@/utils/helpers';
    import { Accordion, AccordionContent, AccordionItem } from '@/components/ui/accordion';
    import { Label } from '@/components/ui/label';
    import { Checkbox } from '@/components/ui/checkbox';

    const props = defineProps<{
        form: any;
        label: string;
        value: string;
    }>();

    const resolvedValue = computed({
        get: () => getByPath(props.form, props.value),
        set: (val) => setByPath(props.form, props.value, val),
    });
</script>

<template>
    <Accordion
        type="single"
        collapsible
        class="hover:border-secondary rounded-md border p-2 transition-[border-color] duration-200"
        :class="{
            'border-secondary': resolvedValue,
            'border-secondary/20': !resolvedValue,
        }"
        :unmount-on-hide="false"
    >
        <AccordionItem
            :value="value"
            :open="resolvedValue"
        >
            <Label
                :for="value"
                class="flex cursor-pointer items-center"
            >
                <Checkbox
                    v-model="resolvedValue"
                    :id="value"
                />
                <span>{{ $t(label) }}</span>
            </Label>
            <AccordionContent
                v-if="$slots.default"
                class="flex flex-col gap-3 pt-3"
            >
                <slot />
            </AccordionContent>
        </AccordionItem>
    </Accordion>
</template>
